<template>
    <div>
        <b-container fluid class="px-0 portfolio-slider">
            <client-only>
                <slick
                ref="imgSlider"
                :options="imgSliderOptions"
                class="slick-for img-slider"
                >
                    <div 
                    v-for="(slide, i) in sliderImages" 
                    class="" 
                    :key="i"
                    >
                        <img 
                            :src="slide.img"
                            class="w-100 d-block"
                            :alt="slide.alt"
                        >
                    </div>
                </slick>
            </client-only>
        </b-container>
    </div>
</template>

<script>
export default {
    props: ['sliderImages'],
    data() {
        return {
            imgSliderOptions: {
                fade: true,
                slidesToShow: 1,
                arrows: false,
                dots: false,
                infinite: true,
                vertical: false,
                lazyLoad: 'ondemand',
                verticalSwiping: false,
                asNavFor: null,
                autoplay: true,
                centerMode: false,
                autoplaySpeed: 3000,
                adaptiveHeight: false,
                appendDots: null,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            dots: false,
                            arrows: false,
                        }
                    }
                ]
            }
        }
    },
    beforeMount() {
    },
}
</script>

<style lang="scss" >

.text-slider {
    .slick-list {
        
    }
}

.portfolio-slider {
    .img-slider {
        margin-bottom: -6px;
    }
    .slick-dotted.slick-slider {
        margin-bottom: -6px;
    }   
    .slider-dots {
        .slick-dots {
            position: relative;
            bottom: 0;
            // left: 93px;
            // display: inline-block;
            width: auto;
            padding: 0;
            margin: 30px 0 0;
            list-style: none;
            text-align: left;

            @media screen and (max-width: 823px) {
                left: 50%;
                transform: translateX(-50%);
            }

            li.slick-active {

                button {

                    &::before {
                        font-family: 'slick';
                        font-size: 6px;
                        line-height: 20px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 80px;
                        height: 4px;
                        content: '';
                        text-align: center;
                        opacity: 1;
                        color: black;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        background-color: #fff;
                        border: 1px solid #fff;
                    }
                }
            }

            li {
                width: 80px;

                button {
                    &::before {
                        font-family: 'slick';
                        font-size: 6px;
                        line-height: 20px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 80px;
                        height: 4px;
                        content: '';
                        text-align: center;
                        opacity: .25;
                        color: black;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        background-color: #fff;
                        border: 1px solid #fff;
                    }
                }
            }
        }
    }
}

</style>